module.exports = __webpack_public_path__ + "static/CATALYST-c03c3ab6e4a884931657496e57570c82.jpeg";